import React, { useEffect, useMemo } from "react";
import Home from "pages/Home/Home";
import "./main.scss";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import FaqPage from "pages/Faq/FaqPage";
import TermsPage from "pages/Terms/TermsPage";
import { COUNTRIES, CountryCodeType, routes } from "utils/constants";
import { ThemeEnum, ThemeProvider } from "@pickit/pickit-components";
import i18next from "i18next";
import TagManager from 'react-gtm-module';
import { GTM_ID } from 'utils/constants';

const tagManagerArgs = {
  gtmId: GTM_ID,
};

TagManager.initialize(tagManagerArgs);

const App: React.FC = () => {
  const { pathname } = useLocation();
  const [, country, page] = pathname?.split("/") as [
    undefined,
    CountryCodeType,
    string
  ];
  const countryUpperCase = useMemo(
    () => country.toUpperCase() as CountryCodeType,
    [country]
  );
  useEffect(() => {
    if (COUNTRIES.includes(countryUpperCase))
      i18next.changeLanguage(`es_${countryUpperCase}`);
  }, [country, countryUpperCase, page]);

  return (
    <ThemeProvider theme={ThemeEnum.pickers}>
      <Switch>
        <Route exact path={routes.INDEX}>
          <Home />
        </Route>
        <Route exact path={routes.FAQ}>
          {countryUpperCase && COUNTRIES.includes(countryUpperCase) && page === "faq" ? (
            <FaqPage />
          ) : (
            <Redirect to={routes.INDEX} />
          )}
        </Route>
        <Route exact path={routes.TERMS}>
          {countryUpperCase && COUNTRIES.includes(countryUpperCase) && page === "terms" ? (
            <TermsPage countryCode={countryUpperCase} />
          ) : (
            <Redirect to={routes.INDEX} />
          )}
        </Route>
        <Route>
          <Redirect to={routes.INDEX} />
        </Route>
      </Switch>
    </ThemeProvider>
  );
};

export default App;
